import { render, staticRenderFns } from "./NoteSeeding.vue?vue&type=template&id=1d94209a&scoped=true&lang=html"
import script from "./NoteSeeding.vue?vue&type=script&lang=js"
export * from "./NoteSeeding.vue?vue&type=script&lang=js"
import style0 from "./NoteSeeding.vue?vue&type=style&index=0&id=1d94209a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d94209a",
  null
  
)

export default component.exports